// MATRIVON Toolkit / Resources — tool reviews.
export const RESOURCE_CATEGORIES = [
  "AI & Research",
  "Market Intelligence",
  "CRM & Sales",
  "Business Development",
  "Productivity",
  "International Business",
  "Data & Analytics",
  "Website & SEO",
  "Technical & Industrial Resources",
];

// Each tool follows the MATRIVON review template.
export const RESOURCES = [
  {
    slug: "perplexity",
    name: "Perplexity",
    category: "AI & Research",
    tagline: "AI answer engine with cited sources.",
    reviewed: "2026-06-01",
    affiliate: false,
    whatItDoes: "An AI-powered research assistant that answers questions with linked, citable sources, useful for fast first-pass desk research.",
    bestFor: "Rapid landscape scans, source discovery and getting oriented in an unfamiliar topic.",
    addsValue: "Speeds up early research and surfaces sources you can then verify independently.",
    doesNot: "Reliable primary data in niche industrial markets, or judgement on source credibility.",
    consider: "Consultants, analysts and business developers doing broad desk research.",
    notFor: "Anyone needing verified, decision-grade data without independent checking.",
    pros: ["Fast, source-linked answers", "Good for orientation and discovery", "Handles broad topics well"],
    limitations: ["Weak on niche industrial data", "Sources still need verification", "Not a substitute for primary research"],
    alternatives: ["ChatGPT with browsing", "Traditional search + industry databases"],
    pricing: "Free tier; paid Pro subscription.",
    assessment: "A genuinely useful accelerator for the first stage of research, provided outputs are treated as hypotheses to verify rather than conclusions.",
    url: "https://www.perplexity.ai",
  },
  {
    slug: "chatgpt",
    name: "ChatGPT",
    category: "AI & Research",
    tagline: "General-purpose AI assistant for drafting and analysis.",
    reviewed: "2026-06-01",
    affiliate: false,
    whatItDoes: "A general-purpose AI assistant for drafting, summarising, structuring analysis and working through documents.",
    bestFor: "Drafting frameworks, summarising material, structuring proposals and first-pass analysis.",
    addsValue: "Removes drudgery from writing and structuring, freeing time for judgement.",
    doesNot: "Guarantee factual accuracy or provide reliable niche market data.",
    consider: "Independent advisors and commercial teams for drafting and synthesis.",
    notFor: "Fact-critical outputs used without review.",
    pros: ["Versatile and fast", "Strong drafting and structuring", "Broad general knowledge"],
    limitations: ["Can produce confident errors", "Limited niche industrial depth", "Needs careful prompting and review"],
    alternatives: ["Claude", "Gemini"],
    pricing: "Free tier; paid Plus/Team subscriptions.",
    assessment: "An excellent productivity multiplier for drafting and synthesis when paired with human review of anything factual.",
    url: "https://chat.openai.com",
  },
  {
    slug: "statista",
    name: "Statista",
    category: "Market Intelligence",
    tagline: "Aggregated market and industry statistics.",
    reviewed: "2026-06-01",
    affiliate: false,
    whatItDoes: "A statistics and market data platform aggregating figures across industries and geographies.",
    bestFor: "Quick access to market sizing, trends and reference statistics for presentations and proposals.",
    addsValue: "Saves time locating headline figures and provides citable data for reports.",
    doesNot: "Deep, niche industrial specialty-chemical data, which is often unavailable anywhere.",
    consider: "Consultants and business development teams needing referenceable market data.",
    notFor: "Highly specialised industrial niches with no public statistics.",
    pros: ["Broad coverage", "Citable figures", "Time-saving for reports"],
    limitations: ["Thin in niche industrial segments", "Subscription cost", "Data recency varies"],
    alternatives: ["Industry association reports", "Specialist market research firms"],
    pricing: "Limited free access; paid subscriptions.",
    assessment: "Useful for broad market context and citable headline figures, but not a source for deep specialty-chemical intelligence.",
    url: "https://www.statista.com",
  },
  {
    slug: "hubspot-crm",
    name: "HubSpot CRM",
    category: "CRM & Sales",
    tagline: "Accessible CRM with a strong free tier.",
    reviewed: "2026-06-01",
    affiliate: false,
    whatItDoes: "A customer relationship management platform for tracking contacts, deals and sales activity.",
    bestFor: "Smaller B2B teams wanting an approachable CRM without heavy setup.",
    addsValue: "Brings structure and visibility to a sales pipeline quickly.",
    doesNot: "Serve the most complex, highly customised industrial sales processes as well as heavier platforms.",
    consider: "SMEs and growing B2B organisations building sales discipline.",
    notFor: "Very large enterprises with deeply customised requirements.",
    pros: ["Generous free tier", "Easy to adopt", "Good for smaller teams"],
    limitations: ["Costs rise with add-ons", "Less suited to very complex processes"],
    alternatives: ["Pipedrive", "Salesforce"],
    pricing: "Free CRM; paid Sales/Marketing hubs.",
    assessment: "A pragmatic choice for industrial SMEs bringing structure to their pipeline, with a genuinely useful free tier.",
    url: "https://www.hubspot.com",
  },
  {
    slug: "pipedrive",
    name: "Pipedrive",
    category: "CRM & Sales",
    tagline: "Pipeline-focused CRM for sales teams.",
    reviewed: "2026-06-01",
    affiliate: false,
    whatItDoes: "A sales-focused CRM built around visual pipeline management and activity tracking.",
    bestFor: "Sales-led B2B teams that want a clear, activity-driven pipeline.",
    addsValue: "Keeps sales teams focused on the next action and pipeline health.",
    doesNot: "Provide the breadth of a full marketing/service suite.",
    consider: "Industrial B2B sales teams focused on deal execution.",
    notFor: "Organisations needing an all-in-one marketing platform.",
    pros: ["Clear pipeline view", "Sales-focused", "Straightforward to use"],
    limitations: ["Narrower than all-in-one suites", "Add-ons for advanced needs"],
    alternatives: ["HubSpot CRM", "Salesforce"],
    pricing: "Paid tiers by feature level.",
    assessment: "A focused, effective tool for teams whose priority is disciplined pipeline execution rather than broad marketing automation.",
    url: "https://www.pipedrive.com",
  },
];

export function getResource(slug) {
  return RESOURCES.find((r) => r.slug === slug);
}
